import React, { useEffect, useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { MobilePlatform } from "@state/stores/types";
import { useRootAppStore } from "@hooks";
import { setTabTitle } from "@utils";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";
import { useAppContext } from "@state/hooks/shared";

export default function Error404(props: { path404: string }) {
	const { t } = useTranslation();
	const { culture } = useAppContext();
	const { pageStore } = useRootAppStore<MobilePlatform>();
	const { path404 } = props;

	useLayoutEffect(() => {
		pageStore.setMinimalPageHeader();
	}, []);

	useEffect(() => {
		setTabTitle("404");
		document.querySelector("html, body")?.scrollTo(0, 0);
	}, []);

	return (
		<>
			<div className="container container--base">
				<div className="card">
					<div className="card__header">
						<div className="card__title">
							{t<string>("ERROR.404.PAGE_NOT_FOUND")}
						</div>
					</div>
					<div
						className="u-type--sml u-color--text--tertiary u-mar--left--sml u-mar--right--xsml"
						style={{ overflowWrap: "break-word" }}
					>
						{path404}
					</div>
					<div className="card__body">
						<div className="u-mar--bottom--xsml">
							<strong>
								{t<string>("ERROR.404.PAGE_HAS_NOT_BEEN_FOUND")}
							</strong>
						</div>
						<div>{t<string>("ERROR.404.REASONS")}</div>
						<ul className="list list--circle">
							<li>{t<string>("ERROR.404.URL_RELOCATED")}</li>
							<li>{t<string>("ERROR.404.URL_INCORRECT")}</li>
							<li>{t<string>("ERROR.404.URL_UNAVAILABLE")}</li>
							<li>
								{t<string>("ERROR.404.SUPPORT_HELP")}{" "}
								<Link
									to={`/${culture}/info/contact`}
									className="u-anchor u-anchor--primary u-type--wgt--medium"
								>
									{t<string>("ERROR.404.HERE_LINK")}
								</Link>
							</li>
						</ul>
					</div>
					<div className="card__footer">
						<Link
							className="card__footer__btn btn btn--base btn--block btn--primary--inverted"
							to={`/${culture}/${DefaultPath.HOME}`}
						>
							<i className="u-icon u-icon--med u-icon--nav--home u-mar--right--xsml"></i>
							{t<string>("ERROR.404.BACK_TO_HOME")}
						</Link>
					</div>
				</div>
			</div>
		</>
	);
}
